import { createReducer } from 'deox';
import produce from 'immer';
import { RefundState } from './types';
import {
  getRefundsAction,
  createRefundAction,
  refundDetailsAction,
  uploadAttachmentsAction,
} from './actions';

const initialState: RefundState = {
  isLoading: {
    list: false,
    create: false,
    retrieve: false,
    uploadAttachments: false,
  },
  errors: {
    list: null,
    create: null,
    retrieve: null,
    uploadAttachments: null,
  },
  list: null,
  uploadId: null,
  current: null,
};

export const refundsReducer = createReducer(initialState, handle => [
  // Обработка получения списка возвратов
  handle(getRefundsAction.request, state =>
    produce(state, draft => {
      draft.isLoading.list = true;
      draft.errors.list = null;
    }),
  ),
  handle(getRefundsAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = null;
      draft.list = payload;
    }),
  ),
  handle(getRefundsAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = payload;
    }),
  ),

  // Обработка создания возврата
  handle(createRefundAction.request, state =>
    produce(state, draft => {
      draft.isLoading.create = true;
      draft.errors.create = null;
    }),
  ),
  handle(createRefundAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.create = false;
      draft.errors.create = null;
      draft.uploadId = payload.pk;
      draft.list = draft.list ? [...draft.list, payload] : [payload];
    }),
  ),
  handle(createRefundAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.create = false;
      draft.errors.create = payload;
    }),
  ),

  // Обработка получения конкретного возврата
  handle(refundDetailsAction.request, state =>
    produce(state, draft => {
      draft.isLoading.retrieve = true;
      draft.errors.retrieve = null;
    }),
  ),
  handle(refundDetailsAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.retrieve = false;
      draft.errors.retrieve = null;
      draft.current = payload;
    }),
  ),
  handle(refundDetailsAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.retrieve = false;
      draft.errors.retrieve = payload;
    }),
  ),

  // Обработка загрузки вложений
  handle(uploadAttachmentsAction.request, state =>
    produce(state, draft => {
      draft.isLoading.uploadAttachments = true;
      draft.errors.uploadAttachments = null;
    }),
  ),
  handle(uploadAttachmentsAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.uploadAttachments = false;
      draft.errors.uploadAttachments = null;
      if (draft.current) {
        draft.current.attachments = payload;
      }
      draft.uploadId = null;
    }),
  ),
  handle(uploadAttachmentsAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.uploadAttachments = false;
      draft.errors.uploadAttachments = payload;
    }),
  ),
]);
